import * as React from "react";
import GlobalStyles from "@mui/material/GlobalStyles/GlobalStyles";
import TopBar from "../../components/TopBarV2";
import Container from "@mui/material/Container/Container";
import Typography from "@mui/material/Typography/Typography";
import Link from "@mui/material/Link/Link";
import Stack from "@mui/material/Stack/Stack";
import { useFormik } from 'formik';
import Box from "@mui/material/Box/Box";
import Button from "@mui/material/Button/Button";
import TextField from "@mui/material/TextField/TextField";
import MenuItem from "@mui/material/MenuItem/MenuItem";
import {styled} from "@mui/material";

import PlayCircleOutlineOutlined from '@mui/icons-material/PlayCircleOutlineOutlined'
import AddProjectValidation from "../../validation/addProjectValidation";
import CancelIcon from '@mui/icons-material/Cancel';
import firebase from "../../firebase/firebase";
import {useContext} from "react";
import {AuthUserContext} from "../../providers/AuthProvider";
import Spinner from "../../components/spinner";
import {useNavigate, useParams} from "react-router-dom";
import ModeEditOutlineOutlinedIcon from '@mui/icons-material/ModeEditOutlineOutlined';
import moment from 'moment'
import * as yup from "yup";
import ScrollToTop from "../../utils/scrollTop";
import { Delete } from "@mui/icons-material";
const storageRef = firebase.storage().ref();
function AddProjectArtists({parentcallback}) {
  const { user, profile} = useContext(AuthUserContext);
  const [projectImage, setProjectImage] = React.useState();
  const [projectCoverImage, setProjectCoverImage] = React.useState();
  const [projectTrailer, setProjectTrailer] = React.useState();
  const [loading, setLoading] = React.useState(true);
  const [error , setError] = React.useState(false);
  const navigator = useNavigate()
  const Input = styled('input')({
    display: 'none',
  })
  let { projectId } = useParams();
  const [edit, setEdit] = React.useState(!projectId);

  const [initialValues, setInitialValues] = React.useState(AddProjectValidation.initialValues)
  const [mediaFilesValue, setMediaFilesValues]  = React.useState()
  const [mediaFiless, setMedia]  = React.useState([])
  const uploadFile = (folder, title) => {
    return new Promise( (resolve, reject) => {
      const file = folder === 'image' ? projectImage.file : folder === 'cover' ? projectCoverImage.file : projectTrailer.file;
      const path = `profiles/${profile.uid}/portfolio/${title}/${folder}/${file.name}`
      const uploadTask = storageRef.child(path).put(file);

// Register three observers:
// 1. 'state_changed' observer, called any time the state changes
// 2. Error observer, called on failure
// 3. Completion observer, called on successful completion
      uploadTask.on('state_changed',
        (snapshot) => {
          // Observe state change events such as progress, pause, and resume
          // Get task progress, including the number of bytes uploaded and the total number of bytes to be uploaded
          var progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
          console.log('Upload is ' + progress + '% done');
          switch (snapshot.state) {
            case firebase.storage.TaskState.PAUSED: // or 'paused'
              console.log('Upload is paused');
              break;
            case firebase.storage.TaskState.RUNNING: // or 'running'
              console.log('Upload is running');
              break;
          }
        },
        (error) => {
          reject(error);

          // Handle unsuccessful uploads
        },
        () => {
          // Handle successful uploads on complete
          // For instance, get the download URL: https://firebasestorage.googleapis.com/...
          resolve(path);
        }
      );
    });
  }
  const uploadFileEdit = (folder, title, file) => {
    return new Promise( (resolve, reject) => {
      const path = `profiles/${profile.uid}/portfolio/${title}/${folder}/${file.name}`
      const uploadTask = storageRef.child(path).put(file);

// Register three observers:
// 1. 'state_changed' observer, called any time the state changes
// 2. Error observer, called on failure
// 3. Completion observer, called on successful completion
      uploadTask.on('state_changed',
        (snapshot) => {
          // Observe state change events such as progress, pause, and resume
          // Get task progress, including the number of bytes uploaded and the total number of bytes to be uploaded
          var progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
          console.log('Upload is ' + progress + '% done');
          switch (snapshot.state) {
            case firebase.storage.TaskState.PAUSED: // or 'paused'
              console.log('Upload is paused');
              break;
            case firebase.storage.TaskState.RUNNING: // or 'running'
              console.log('Upload is running');
              break;
          }
        },
        (error) => {
          reject(error);

          // Handle unsuccessful uploads
        },
        () => {
          // Handle successful uploads on complete
          // For instance, get the download URL: https://firebasestorage.googleapis.com/...
          resolve(path);
        }
      );
    });
  }
  const formik = useFormik({
    initialValues: {

      title: '',
      description: '',
      role: '',
      imdb: '',
    },
    validationSchema: yup.object({


      title: yup.string('Project title').required('Project title required'),
      description: yup.string('Description').required('Description required'),
      role: yup.string('role'),
      imdb: yup.string('imdb').matches(/imdb.com/, "Please enter valid IMDb url").url("The link must be a valid url"),
    })
    ,
    onSubmit: async (values) => {
      try {
         
        setLoading(true)
        const cover = await uploadFile('cover', values.title);
           /*
        * TODO: Media files uploading
        * */
       //  Media Files Upload done
        let gallery = []
        if(mediaFiless.length>0){
          for(let x of mediaFiless){
            if(x.document && x.document!==""){
              const url = await uploadFileEdit('mediaGallery', values.title, x.document)
              gallery.push(url)
            }else{
              gallery.push(x.url)
            }
          }
        }

        
     


        const projectRef = firebase.firestore().collection('users').doc(profile.id);
        const getProfile = await projectRef.get();
        if (getProfile.data() && getProfile.data().portfolio) {
          const portfolios = getProfile.data().portfolio;
          portfolios.push({
            ...values,

            mediaFiles: {
              cover,
              gallery,
            },

            uid: user.uid,
          })
          projectRef.update({
            portfolio: portfolios
          })
        } else {
          projectRef.update({
            portfolio: [
              {
                ...values,

                mediaFiles: {
                  cover,
                  gallery,
                },
              }
            ]
          })
        }
        setLoading(false)
        parentcallback(false)
        // setTimeout(() => alert('Successfully add project'), 500)

      } catch (e) {
        setLoading(false)
        console.log(e);
        setError(true)
      }

    },
  });
  const downloadURL = (url) => new Promise(((resolve, reject) => {
    const mediaRef = storageRef.child(url);

// Get the download URL
    mediaRef.getDownloadURL()
      .then((url) => {
        resolve(url);
        // setImageUrl(url)
        // setLoading(false)
        // Insert url into an <img> tag to "download"
      })
      .catch((error) => {
        reject(error)
        // setLoading(false)

        // A full list of error codes is available at
        // https://firebase.google.com/docs/storage/web/handle-errors
        switch (error.code) {
          case 'storage/object-not-found':
            // File doesn't exist
            break;
          case 'storage/unauthorized':
            // User doesn't have permission to access the object
            break;
          case 'storage/canceled':
            // User canceled the upload
            break;

          // ...

          case 'storage/unknown':
            // Unknown error occurred, inspect the server response
            break;
        }
      });
  }))
  React.useEffect(() => {
    if (projectId) {
      const projectRef = firebase.firestore().collection('projects').doc(projectId);
      projectRef.get()
        .then(async (snapshot) => {
          setLoading(false)
          setMediaFilesValues(snapshot.data().mediaFiles);
          formik.setValues({
            ...snapshot.data(),
          });
          if (snapshot.data().mediaFiles) {
            if (snapshot.data().mediaFiles.cover) {
              const cover = await downloadURL(snapshot.data().mediaFiles.cover)
              setProjectCoverImage({src: cover,
              })
            }
            if (snapshot.data().mediaFiles.image) {
              const image = await downloadURL(snapshot.data().mediaFiles.image)
              setProjectImage({src: image, })
            }
            if (snapshot.data().mediaFiles.trailer) {
              const mediaRef = storageRef.child(snapshot.data().mediaFiles.trailer);
              const metadata = await mediaRef.getMetadata();
              const trailer = await downloadURL(snapshot.data().mediaFiles.trailer)
              setProjectTrailer({src: trailer,size: (metadata?.size / 1024 / 1024).toFixed(2)})
            }
          }
        })
        .catch((err) => setLoading(false))
    }
    else setLoading(false)
  }, []);
  if (loading) return <Spinner/>
  return(
    <React.Fragment>
      <ScrollToTop/>
      <GlobalStyles styles={{ ul: { margin: 0, padding: 0, listStyle: 'none' } }} />
      {/* Hero unit */}


      <Container maxWidth="md" sx={{textAlign: 'left', py:5}} onSubmit={formik.handleSubmit}>


        <Stack  direction="row" alignItems="flex-end" justifyContent={'flex-start'}  spacing={5}>
          <Stack direction={'column'}  alignItems="center" spacing={2} sx={{width:'250px'}}>
            {
              projectCoverImage && projectCoverImage.src ?
                <Box  sx={{ width:'100%',  height: 200, backgroundColor: edit && projectId ? '#000' : 'none', borderRadius: '14px' }}>
                  <img src={projectCoverImage.src} style={{width:'100%',  height: 200, borderRadius: '0px', position: 'relative',objectFit:'cover', top: 0,
                    right: 0, opacity: edit && projectId ? .5 : 1, }} alt=""/>
                  {projectId && edit &&
                    <label htmlFor="project-cover-edit">

                      <Input accept="image/*" id="project-cover-edit" multiple={false} type="file" onChange={(e) => {
                        const fileReader = new FileReader();
                        fileReader.readAsDataURL(e.target.files[0]);
                        fileReader.addEventListener("load", async function () {
                          setProjectCoverImage({
                            src: this.result,
                            file: e.target.files[0]
                          });
                          if(projectId) {
                            const cover = await uploadFileEdit('cover', formik.values.title, e.target.files[0]);
                            const projectRef = firebase.firestore().collection('projects').doc(projectId);
                            await projectRef.update({mediaFiles: {...mediaFilesValue, cover}})
                            setMediaFilesValues({...mediaFilesValue,cover})
                          }
                        });
                      }} />
                      <Button sx={{  position: 'relative',
                        top: '-70%',
                        right:' -40%',
                        color:' #ffffffa6',
                        fontWeight: 600,}}  component="span">change cover image</Button>
                    </label>

                  }
                </Box> :



                <label htmlFor={'project-cover-image'}>
                  <Stack direction={'row'}
                         justifyContent="center"
                         alignItems="center"
                         spacing={1}
                         sx={{width:'100%',  height:200, border: '1px solid rgba(0, 0, 0, 0.23)', borderRadius: '0px'}}>
                    <Input accept="image/*" id="project-cover-image" multiple={false} type="file" onChange={(e) => {
                      const fileReader = new FileReader();
                      fileReader.readAsDataURL(e.target.files[0]);
                      fileReader.addEventListener("load", function () {
                        setProjectCoverImage({
                          src: this.result,
                          file: e.target.files[0]
                        });
                      });
                    }}/>

                    <Button component="span" fullWidth  color={!error ?'secondary': 'error'}  startIcon={<img src="/assets/upload-icon.png" style={{width: 36, height: 36, marginRight: 15}} alt=""/>}>
                      <>Upload project image</>
                    </Button>

                  </Stack>
                </label>

            }
          </Stack>
          <Stack direction={'column'}  sx={{flex:1,}} spacing={5}>
            <TextField fullWidth label={'Project Title*'} size={'medium'}
                       value={formik.values.title}
                       onChange={formik.handleChange}
                       error={formik.touched.title && Boolean(formik.errors.title)}
                       helperText={formik.touched.title && formik.errors.title}
                       name="title"
            />
            <TextField fullWidth  name={'role'} label={'Your role'} value={formik.values.role}
                       onChange={formik.handleChange}
                       error={formik.touched.role && Boolean(formik.errors.role)}
                       helperText={formik.touched.role && formik.errors.role}/>

          </Stack>
        </Stack>
        <Stack direction={'column'}
               justifyContent="start"
               alignItems="start"
               spacing={3}
               sx={{width:'100%', mt:5, pl: 1}}   component={'form'}  >

          <TextField fullWidth  name={'imdb'} label={'IMDb link to project'} value={formik.values.imdb}
                     onChange={formik.handleChange}
                     error={formik.touched.imdb && Boolean(formik.errors.imdb)}
                     helperText={formik.touched.role && formik.errors.imdb}/>

          <TextField fullWidth label={'Describe the project in 100-150 Words'} size={'medium'}
                     value={formik.values.description}
                     onChange={formik.handleChange}
                     error={formik.touched.description && Boolean(formik.errors.description)}
                     helperText={formik.touched.description && formik.errors.description}

                     multiline
                     rows={5}
                     name="description"
          />

          <Typography variant={"body1"} >
            Add media related to the project
          </Typography>

          <Stack
            direction={{md:"row", sx: 'column'}}
            justifyContent="flex-start"
            alignItems="flex-start"
            spacing={3}
          >
            <Stack sx={{height: 128, width: 128, borderRadius: '10px', border: '1px solid #ccc'}} direction={'column'} justifyContent="center"
                   alignItems="center">
              <label htmlFor={`mediaFiles`}>

                <Button component={'span'}>
                  <img src="/assets/icons/profile-project-cover-icon.png" alt=""/>
                </Button>
                <Input accept="image/*" id={`mediaFiles`} multiple={true} type="file" onChange={async (e)=>{
                  let mediaGallery = mediaFiless
                  for(let q = 0; q < e.target.files.length; q++){
                    const file = e.target.files.item(q)
                    const fileReader = new FileReader();
                    fileReader.readAsDataURL(file);
                    fileReader.addEventListener("load", async function () {
                      mediaGallery.push({src: this.result, document: file, progress:0})
                      if (q === e.target.files.length - 1) {
                        
                      }
                      // console.log(mediaFiless)
                      setMedia(prev => [...mediaGallery])
                    });
                  }
                }} />

              </label>
            </Stack>
            {mediaFiless && mediaFiless.length > 0 &&
              mediaFiless.map((d, ind) =>
              <span className="project-container">
                
										<span className="overlay">
										<Delete className="delete-media"
										onClick={()=>{
                        const media = [...mediaFiless]
                        media.splice(ind, 1)
                        setMedia(media)
                        // const mediaFiles= arrayHelpers.form.values.projects[i].mediaFiles.filter(v=> v.document !== d.document)
                        }}
										/></span>
																						
                <img src={d?.src} style={{width:128,height: 128, objectFit: 'cover', borderRadius: '10px', border: '1px solid #ccc'}} alt={d?.document?.name}/>

              </span>
              )
            }


          </Stack>



          <Stack spacing={2} direction="row" sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            width: '100%'
          }}>
            <Button  sx={{pt: 1.2, pb:1.2, pl: 5, pr:5,  textDecoration:'underline'}}  onClick={() => parentcallback(false)}>Quit without saving</Button>

            <Button variant="contained" sx={{pt: 1.2, pb:1.2, pl: 5, pr:5,backgroundColor:'#FD4A01'}} color={'warning'} type={'submit'} >Save Changes</Button>
          </Stack>
        </Stack>
      </Container>

    </React.Fragment>
  )
}
export default AddProjectArtists;